<script>
  import { External, M } from '../../../external';
  import AuthorAvatar from '../../../Common/AuthorAvatar.svelte';
  import WallsWidgetService from '../service';

  export let wrapperClasses = '',
    author,
    timestamp,
    showBadge,
    onApprovePost,
    isWaitingApproval;

  let isModerator = false;
  WallsWidgetService.isModerator().then((res) => (isModerator = res));

  const truncateIfLong = (text) => {
    const TRUNCATE_LENGTH = 50;

    if (!text) {
      return '';
    }

    if (text.length > TRUNCATE_LENGTH) {
      return text.substring(0, TRUNCATE_LENGTH) + '...';
    }
    return text;
  };

  const getTimeAgo = (timestamp) => {
    const time = (Date.now() - timestamp * 1000) / 1000;
    if (time < 60) {
      return M.LESS_THAN_MINUTE_AGO;
    }
    if (time >= 60 && time < 60 * 60) {
      let conv = Math.floor(time / 60);
      if (conv === 1) {
        return M.MINUTE_AGO;
      }
      return External.format(M.MINUTES_AGO, 'x', conv);
    }
    if (time >= 60 * 60 && time < 60 * 60 * 24) {
      let conv = Math.floor(time / 60 / 60);
      if (conv === 1) {
        return M.HOUR_AGO;
      }
      return External.format(M.HOURS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 && time < 60 * 60 * 24 * 7) {
      let conv = Math.floor(time / 60 / 60 / 24);
      if (conv === 1) {
        return M.DAY_AGO;
      }
      return External.format(M.DAYS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 * 7 && time < 60 * 60 * 24 * 30) {
      let conv = Math.floor(time / 60 / 60 / 24 / 7);
      if (conv === 1) {
        return M.WEEK_AGO;
      }
      return External.format(M.WEEKS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 * 30 && time < 60 * 60 * 24 * 365) {
      let conv = Math.floor(time / 60 / 60 / 24 / 30);
      if (conv === 1) {
        return M.MONTH_AGO;
      }
      return External.format(M.MONTHS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 * 365) {
      let conv = Math.floor(time / 60 / 60 / 24 / 365);
      if (conv === 1) {
        return M.YEAR_AGO;
      }
      return External.format(M.YEARS_AGO, 'x', conv);
    }

    return getDateString(timestamp);
  };
</script>

{#if author}
  <div class="circle-post-author {wrapperClasses} flex align-center">
    <AuthorAvatar {author} />
    <span class:mr-25={!timestamp} class="circle-post-author-name">{truncateIfLong(author.name)}</span>

    {#if timestamp}
      <span class="circle-post-time">{getTimeAgo(timestamp)}</span>
    {/if}
  </div>
  {#if isWaitingApproval}
    {#if isModerator}
      <div style="cursor: pointer;" on:click={onApprovePost} class="circle-post-badge moderator">
        {M.APPROVE}
      </div>
    {:else}
      <div class="circle-post-badge moderator">{M.WAITING_APPROVAL}</div>
    {/if}
  {/if}
  {#if showBadge}
    <!--    <div class="circle-post-badge moderator">Dragon</div>-->
  {/if}
{/if}
